import React, { ElementRef, useMemo } from 'react';

import { Box } from '@chakra-ui/react';
import { CustomHeaderCell } from 'screens/Team/Rabbit/Goals/AgGridTreeView/components/CustomHeaderCell';

import { AgGridWrapper } from 'uiToolkitV1/AgGridWrapper';

import { useRolesToCreateConfigSelector } from '../../../slice/accessControlSlice';
import { createTableColDefs } from '../../constants/colDefs/createTableColDefs';
import { createKeyResultDropdownValues, createObjectiveDropdownValues } from '../../constants/privileges/CreateTable';
import { CREATE_TABLE_ROLES } from '../../constants/roles';

function transformRowDataForAgGrid(rowData: Array<{ [key: string]: any }>) {
  const transformedData = rowData.map((row) => {
    const { name, value, ...rest } = row ?? {};
    let transformedRow = { name, value, ...(rest as any) };
    const subKeys = Object.keys(rest);
    for (const subKey of subKeys) {
      if (subKey === 'createObjective') {
        transformedRow = {
          ...transformedRow,
          [subKey]: {
            ...transformedRow[subKey],
            dropdownValues: createObjectiveDropdownValues,
          },
        };
      } else if (subKey === 'createKeyResult') {
        transformedRow = {
          ...transformedRow,
          [subKey]: {
            ...transformedRow[subKey],
            dropdownValues: createKeyResultDropdownValues,
          },
        };
      }
    }
    return transformedRow;
  });

  return transformedData;
}

const rowDataForAgGrid = (rolesToCreateConfig) =>
  CREATE_TABLE_ROLES.map((role) => ({
    name: role.name,
    value: role.value,
    ...(rolesToCreateConfig[role.value] ?? {}),
  }));

interface Props {}

const CreateAccessTable = (props: Props) => {
  const gridRef = React.useRef<ElementRef<typeof AgGridWrapper>>(null);

  const { rolesToCreateConfig } = useRolesToCreateConfigSelector();

  const data = transformRowDataForAgGrid(rowDataForAgGrid(rolesToCreateConfig));

  // useEffect(() => {
  //   if (gridRef.current?.api && data) {
  //     gridRef?.current?.api.resetRowHeights();
  //     console.log('resetRowHeights');
  //   }
  // }, [gridRef, data]);

  const defaultColDef = useMemo(
    () => ({
      flex: 0,
      menuTabs: ['filterMenuTab'],
      headerComponent: CustomHeaderCell,
    }),
    []
  );

  // const getRowHeight = useCallback((params) => {
  //   console.log('getRowHeight');
  //   const selectedValues = (params?.data?.createObjective?.values as []) ?? [];
  //   const noOfSelectedValues = selectedValues.filter((value) => value).length;
  //   if (noOfSelectedValues === 1) return 80;
  //   return noOfSelectedValues * 30 + 20;
  // }, []);

  const gridStatePersistenceKey = null;

  return (
    <Box className="ag-theme-alpine" style={{ width: '100%', height: '600px' }}>
      <AgGridWrapper
        gridStatePersistenceKey={gridStatePersistenceKey}
        useFilterModelPersistence={false}
        useColumnStatePersistence={false}
        ref={gridRef}
        rowData={data}
        columnDefs={createTableColDefs}
        animateRows
        rowHeight={130}
        // getRowHeight={getRowHeight}
        suppressRowTransform
        suppressMenuHide
        getRowId={(data) => data?.data?.value}
        // @ts-ignore
        defaultColDef={defaultColDef}
      />
    </Box>
  );
};

export { CreateAccessTable };
